import {HttpHeaders} from '@angular/common/http';

export class IamAppConstants {
  static readonly Mode = {
    CREATE: 'create',
    EDIT: 'edit',
    VIEW: 'view'
  };
  static readonly header = new HttpHeaders().set(
    'Content-Type',
    'application/json; charset=utf-8'
  );
  public static readonly token = 'token';
  public static readonly acls = 'acls';
  public static readonly roles = 'roles';
  public static readonly preferences = 'preferences';
  public static readonly privileged = 'privileged';

  public static readonly current_user_identity_details = 'current_user_identity_details';
  public static readonly current_user_profile_details = 'current_user_profile_details';
  public static readonly redirect_url = 'redirect_url';

  static readonly AuthType = {
    DB_AUTH: 'DB_AUTH',
    SSO: 'SSO',
    MFA: 'MFA'
  };
  public static readonly lockScreenUrl = '/public/users/screen-lock';
  static readonly no_acl_page_private = '/app/access-denied/landing-no-access';
  static readonly access_denied_page = 'auth/access-denied';
  static readonly auth_login = '/auth/login';

  static handleDropdownKey(event: KeyboardEvent) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      (event.target as HTMLElement).click();
    }
  }
}
